import {createContext, useState } from "react";

let AuthContext = createContext(null);

export function AuthProvider({children}) {
	let [user, setUser] = useState(null);
	let [permissionLevel, setPermissionLevel] = useState(0);
	let value = {user, setUser, permissionLevel, setPermissionLevel};

	return <AuthContext.Provider value={value}> {children} </AuthContext.Provider>

}

export default AuthContext;

